import CustomHTML from './CustomHTML'

export default CustomHTML;